import { Component, Input, OnDestroy, OnInit, Output, EventEmitter } from '@angular/core';
import { Subscription } from 'rxjs';
import { ScreenView } from '../../constants/global.constant';
import { KngSelectionData, KngStatusSelector, KngStatusSelectorState } from './definitions';
import { KngStatusSelectorService } from './kng-status-selector.service';


@Component({
	selector: 'kng-status-selector',
	templateUrl: './template/kng-status-selector.component.html',
	styleUrls: ['./template/kng-status-selector.component.scss']
})
export class KngStatusSelectorComponent implements KngStatusSelector, OnInit, OnDestroy 
{
    
	selectedStatusValue: string = 'all';
	screenView = ScreenView;
	private subscriptions: Subscription = new Subscription();

    @Input() set state(value: KngStatusSelectorState) 
	{
		this.service.updateState(value);
	}
    get state(): KngStatusSelectorState 
    {
    	return this.service.state;
    }

    @Output() stateChanged: EventEmitter<KngStatusSelectorState> = new EventEmitter<KngStatusSelectorState>();
    @Output() selectionChanged: EventEmitter<KngSelectionData> = new EventEmitter<KngSelectionData>();

    constructor(
        private service: KngStatusSelectorService
    ) { }

    ngOnInit(): void 
    {
    	this.initSubscriptions();
    }
    ngOnDestroy(): void 
    {
    	this.destroySubscriptions();
    }

    private initSubscriptions(): void 
    {
    	const stateChangeSubs: Subscription = this.service.stateChanged.subscribe(
    		(next: KngStatusSelectorState) => this.stateChanged.emit(next)
    	);
    	this.subscriptions.add(stateChangeSubs);
    }
    private destroySubscriptions(): void 
    {
    	this.subscriptions.unsubscribe();
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    onSelectionChange(view: string, event: any): void 
    {
    	const selectedData: KngSelectionData = {
    		selectedStatus: ''
    	};
    	if(view === ScreenView.mobile) 
    	{
    	    selectedData.selectedStatus = event?.target?.value;
    	}
    	else 
    	{
    		this.selectedStatusValue = event;
    		this.state.selectedStatus = event;
    		selectedData.selectedStatus = event;
    	}
    	this.selectionChanged.emit(selectedData);
    }
}
